export default "__VITE_ASSET__BF7jlBLN__"